export const APP_PREFIX = 'next-galaxy-admin';
export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
// export const API_VERSION = import.meta.env.API_VERSION;
export const API_URL = process.env.REACT_APP_API_URL;
export const API_UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;
// export const API_UPLOAD_URL = import.meta.env.VITE_API_UPLOAD_URL;
// export const API_STORAGE_PREFIX = import.meta.env.VITE_API_STORAGE_PREFIX;
// export const API_ADDRESS_URL = import.meta.env.VITE_API_ADDRESS_URL;
//
// export const GOOGLE_MAP_KEY = import.meta.env.VITE_GOOGLE_MAP_KEY;

export const MAP_STARTING_POINT = {
    lat: 47.9189,
    lng: 106.9176
}